import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { products } from '../data/products';

const ProductDetail = () => {
  const { t } = useTranslation();
  const { id } = useParams();

  const product = products.find((p) => p.id === id);

  if (!product) {
    return (
      <div className="container mx-auto px-4 py-16 text-center">
        <h2 className="text-2xl font-semibold text-red-600">
          {t('products.notFound', 'Mahsulot topilmadi')}
        </h2>
        <Link
          to="/products"
          className="mt-6 inline-block bg-etmgreen text-white py-2 px-4 rounded-lg hover:bg-green-600 transition font-techno"
        >
          {t('products.backToList', 'Mahsulotlar ro‘yxatiga qaytish')}
        </Link>
      </div>
    );
  }

  return (
    <div className="flex flex-col space-y-16 pb-16">
      <section className="bg-white py-8">
        <div className="container mx-auto px-4 flex items-center space-x-4">
          <Link to="/products" className="text-etmgreen hover:underline font-techno">
            ← {t('products.back', 'Orqaga')}
          </Link>
          <h1 className="text-3xl md:text-4xl font-extrabold text-gray-800 font-techno">
            {product.name}
          </h1>
        </div>
      </section>

      {/* Mahsulot rasm va asosiy ma’lumotlar */}
      <section className="container mx-auto px-4 grid grid-cols-1 md:grid-cols-2 gap-8 items-start">
        <div className="w-full h-80 bg-gray-100 flex items-center justify-center overflow-hidden rounded-lg">
          <img
            src={product.img}
            alt={product.name}
            className="object-contain h-full"
          />
        </div>

        <div className="space-y-4 font-sans">
          <p className="text-gray-700">{product.desc}</p>
          <p className="text-gray-800">
            <span className="font-semibold font-techno">{t('products.priceLabel', 'Narxi')}:</span> {product.price}
          </p>
          <p className="text-gray-800">
            <span className="font-semibold font-techno">{t('products.warrantyLabel', 'Kafolat')}:</span> {product.warranty}
          </p>
          <div>
            <span className="font-semibold font-techno">{t('products.featuresLabel', 'Xususiyatlar')}:</span>
            <ul className="list-disc list-inside ml-5 mt-2 space-y-1 text-gray-700">
              {product.features.map((feat, idx) => (
                <li key={idx}>{feat}</li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <section className="bg-gray-50 py-16">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-2xl font-bold text-etmgreen mb-4 font-techno">
            {t('products.videoTitle', 'Video qo‘llanma')}
          </h2>

          <div className="relative w-full max-w-4xl mx-auto" style={{ paddingTop: '35%' }}>
            <iframe
              src={`https://www.youtube.com/embed/${product.videoId}`}
              title={t('products.videoTitle', 'Video qo‘llanma')}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="absolute top-0 left-0 w-full h-full rounded-lg shadow-lg"
            ></iframe>
          </div>
        </div>
      </section>

      {/* Qo‘shimcha CTA bo‘limi */}
      <section className="bg-gradient-to-r from-etmgreen to-sky text-white py-16">
        <div className="container mx-auto px-4 text-center space-y-6">
          <h2 className="text-3xl font-bold font-techno">
            {t('products.ctaTitle', 'Bu mahsulotni hoziroq tanlang!')}
          </h2>
          <p className="text-lg font-sans max-w-2xl mx-auto">
            {t(
              'products.ctaText',
              'Savollaringiz bo‘lsa, quyidagi “Aloqa” tugmasi orqali biz bilan bog‘laning.'
            )}
          </p>
          <Link
            to="/contact"
            className="inline-block bg-white text-etmgreen font-semibold py-3 px-8 rounded-full hover:bg-gray-100 transition font-techno"
          >
            {t('products.contactButton', 'Aloqa')}
          </Link>
        </div>
      </section>
    </div>
  );
};

export default ProductDetail;
